import { render, staticRenderFns } from "./Toppings.vue?vue&type=template&id=29701de8&"
import script from "./Toppings.vue?vue&type=script&lang=js&"
export * from "./Toppings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports